import React from 'react';
import { Clock, CheckCircle, AlertCircle } from 'lucide-react';

export default function ConversationCard({ name, message, status, time }) {
  const getStatusIcon = () => {
    switch (status) {
      case 'Traité':
        return <CheckCircle size={16} className="text-green-500" />;
      case 'En attente':
        return <AlertCircle size={16} className="text-yellow-500" />;
      default:
        return <Clock size={16} className="text-text-gray" />;
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'Traité':
        return 'bg-green-500/20 text-green-500';
      case 'En attente':
        return 'bg-yellow-500/20 text-yellow-500';
      default:
        return 'bg-gray-500/20 text-gray-500';
    }
  };

  return (
    <div className="bg-primary-card p-4 rounded-lg shadow-md hover:shadow-green transition-all cursor-pointer border border-transparent hover:border-accent-green/30">
      <div className="flex items-start justify-between gap-2 mb-2">
        <h4 className="text-white font-medium truncate min-w-0">{name}</h4>
        <span className={`text-xs px-2 py-1 rounded-full flex items-center gap-1 flex-shrink-0 whitespace-nowrap ${getStatusColor()}`}>
          {getStatusIcon()}
          {status}
        </span>
      </div>
      <p className="text-text-gray text-sm mb-2 line-clamp-2">{message}</p>
      <p className="text-xs text-text-gray flex items-center gap-1">
        <Clock size={12} />
        {time}
      </p>
    </div>
  );
}
